import { addIgnoreEnum } from "@/apis/dict";
import { DictItem } from "@/types/dict";


//旧字典id备份：
export const oldDicids = [
  "368ae59b010f43068affd5a0f469454e",
  "40096795958b47da943a624958591d80",
  "87e1ede675ca43bbb05a6b1145fcdc67",
  "88ba414296ee4911aebcc53312aa5c30",
  "90c4850cb7364d12a324d5b883692575",
  "b403f7dbffe64cd09f9290217ee5bcbe",
  "d34ef8834c364020b7f74f58bd537d93",
  "da5155853ab94b4fb135fde7a88156c6",
  "0a95219fa655432da4e77fed389cfd3d",
  "57d591c79e29453d82574f8a6b5534c7",
  "72213cb407694633a42074a458ac165b",
  "8d7f7b58e0914726889e2f3bce9deb02",
  "bb690226a24e4dd9a409e3bdcea1aeac",
  "db3be0df5fb64638a4b90af63363c578",
  "04b9b0527ba24db7ba38db18b66cbd0f",
  "39fde68f1f3a4f57b38026b88719fdd0",
  "68c335f4ab3545e8a7dd8f9772d6049e",
  "8f50bb25f381437ab2a6fdc97a431fdd",
  "af6bddaf76954088a8e9d99f183c935a",
  "b61c28e017a64c3d874f9affe1038d5d",
  "b817f707609d427db430c37982531c77",
  "c090054247724aaaa9787e73e8e7df25",
  "2a1b658b6be14199bebdb9ba63ed2233",
  "7b4add8658bb4614bf4a48f202e83fec",
  "c0dfa0ace8584c2d9e1ae79d23cd33ec",
  "d0a65c91984240f0a016177feadcb643",
  "0f889c8d7ca8440097daac7c7076b034",
  "66f29eadd16f41a9b55e2850165e62e2",
  "9b689e4f2e4546ffb152daef1a27cd3f",
  "c777c1a4e4d24d7d81caf76a923876c8",
  "2d10e69e9f4749ef8b4638ea8abded26",
  "4ea639ec88ac45cf88254f441b64f625",
  "8e4e93e802344d8ea42ce9b18c258b4f",
  "c988dd096eb74f15abf2288719a98668",
  "dcc5d6b10886441886417644b80e35f5",
  "f6140b66e6c64d508310a6164f22a625",
  "0310f4a79d0b4c859bc33834d1a31204",
  "4a24d7798b4d42678fbde2b0be4d7698",
  "5ae4892dcb944412807a2682c6a817e0",
  "5c7c734f2f2743e0b22cbf9fad18048a",
  "600388a3cf37436ca01d96c9839486cc",
  "0ba9f197a9fb4c738152b7c76edeba2e",
  "3c189d4bd694477c9a559c4a50c2cb5c",
  "67cf8688df094aabbbe1653fdebee0eb",
  "6f7a35171fcb49a082e60e2f7d86f9d6",
  "82445514c8f34c5091b513f5cfc1a9c9",
  "a686a1fbb4554a31b76b0204f0def096",
  "d0792deb8d074ede8539f6d81437b578",
  "0c3a03cbbc1c408a905fba11c1400018",
  "131095f0d4a646eda0e76eba1cecd27e",
  "47834766caa948238775d24fdd523a62",
  "51e14e7da0044183824ececfc8c3346b",
  "ca5ff44d2d3648528a3990561816390e",
  "cba36dab53e14df6975d2d3e0a82ca34",
  "f0232836a6bc4b9cb72e525832e40e52",
  "4fbe7b431d5c44a0a743822c660d173d",
  "b933bfdafe8a457fb6892756d2f915dd",
  "c251d7312ba546bba4a6ef0bfc9007d9",
  "19d07d1de4914993a4bda4e6b7a56158",
  "378fa52b5f9448e4ade60ababb85068a",
  "5762a640c3a04a6ba0d508aeb6b9add1",
  "5d382dae5f724d2aaa4837b4f3c8dad8",
  "a5d992884df24ca59801477701bfbcce",
  "dea64e14e24041a6bd5f3f8c3d0556a7",
  "e89636922c174646ac45db9c1fed39c3",
  "25557746dbc74a38bcb428e358b1f6e9",
  "479346dd11e04d8eb8feceb83db66427",
  "6d6d9c1e0b3d4704a60252ff83205c04",
  "73ee13b524ff474c89761f7d9ff01f35",
  "7e7d6351f43d423489eeebe5690fc034",
  "aa222657b558469486f5627e7aaeb34a",
  "aa8ff3eddfb04a7f885446e26fe781fc",
  "ad0bb4f5d24f4d8298298febf954c4ff",
  "ad36fbc1120a494a99da791bfb1f1679",
  "c08f51c891034778b02f804a35ca28e8",
  "ed3d90a25c484968ba91d2e3f3802477",
  "f5a0a751dc8c4d73a8bd476cdc6e96be"
];
// 产品类型初始化数据
export const productTypeList: string[] = [
  "电容",
  "电阻",
  "电感"
];

// ===================
//电容的品牌
const DR = [
  'CCTC',
  'SINCERA',
  'SAMSUNG',
  'ketuo',
  'FH',
  'YAGEO',
  'EYANG',
  'GJT',
  '无品牌',
  'Sunlord',
  '松田',
  'Chang',
  '嵩隆力上',
  'GAJITONE',
  'STE',
  'XIANGYEE',
  'KEMET',
  'muRata',
  'SAMYOUNG',
  '湘江'
];

//电阻的品牌
const DZ = [
  'SUNWAY',
  'UniOhm',
  'SINCERA',
  'ROYALOHM',
  'FH',
  'RALEC',
  'YAGEO',
  '无品牌',
  'SEMBO',
  'HONGDA',
  'VDR',
  '嵩隆力上'
];

//电感的品牌
const DG = [
  'Ceaiya',
  'Sunlord',
  '无品牌',
  'YCET',
  'microgate',
  'Cybermax',
  'TAI-TECH',
  'FH',
  'FOUNDS',
  'WS',
  'JuLian',
  'HILISIN',
  'CHILISIN',
  'JY'
];
// =======================
//电容-CCTC的型号
const DRCCTC = [
  '000402X5R154K100AT',
  'TC0603X7R224K250CT',
  'TCC0201C0G101J500ZT',
  'TCC0201C0G120F500CZT',
  'TCC0201C0G150J500ZT',
  'TCC0201C0G180J500ZT',
  'TCC0201C0G200J500ZT',
  'TCC0201C0G220J500ZT',
  'TCC0201C0G270J500ZT',
  'TCC0201C0G300J500ZT',
  'TCC0201C0G330J500ZT',
  'TCC0201C0G331J500ZT',
  'TCC0201C0G680J500ZT',
  'TCC0201COG100J500ZT',
  'TCC0201COG101J500ZT',
  'TCC0201COG200J500Z',
  'TCC0201X5R104K100ZT',
  'TCC0201X5R104K160ZT',
  'TCC0201X5R104K250ZT',
  'TCC0201X5R104K6R3ZT',
  'TCC0201X5R105M100ZT',
  'TCC0201X5R105M6R3ZT',
  'TCC0201X5R224K100ZT',
  'TCC0201X5R224K6R3ZT',
  'TCC0201X5R224M6R3ZT',
  'TCC0201X7R102K500ZT',
  'TCC0201X7R103K500ZT',
  'TCC0201X7R104K160ZT',
  'TCC0201X7R152K500ZT',
  'TCC0201X7R222K500AT',
  'TCC0201X7R471K500ZT',
  'TCC0201X7R472K500ZT',
  'TCC0402C0G101J500AT',
  'TCC0402C0G120J500AT',
  'TCC0402C0G150J500AT',
  'TCC0402C0G160J500AT',
  'TCC0402C0G1O1J500AT',
  'TCC0402C0G200J500AT',
  'TCC0402C0G220J500AT',
  'TCC0402C0G240J500AT',
  'TCC0402C0G270J500AT',
  'TCC0402C0G300J500AT',
  'TCC0402C0G330J500AT',
  'TCC0402C0G390J500AT',
  'TCC0402C0G470J500AT',
  'TCC0402C0G680J500AT',
  'TCC0402C0G820J500AT',
  'TCC0402C0G8R2B500AT',
  'TCC0402COG150F500AT',
  'TCC0402COG180J500AT',
  'TCC0402COG560J500AT',
  'TCC0402X5225K160AT',
  'TCC0402X5R104K250AT',
  'TCC0402X5R105K100AT',
  'TCC0402X5R105K160AT',
  'TCC0402X5R105K500AT',
  'TCC0402X5R105K6R3ATN',
  'TCC0402X5R106M6R3ATR',
  'TCC0402X5R154K100AT',
  'TCC0402X5R224K100AT',
  'TCC0402X5R225K100AT',
  'TCC0402X5R225K250AT',
  'TCC0402X5R225M100AT',
  'TCC0402X5R225M6R3AT',
  'TCC0402X5R474K100AT',
  'TCC0402X5R474K160AT',
  'TCC0402X5R475K6R3AT',
  'TCC0402X5R475M160AT',
  'TCC0402X5R475M6R3AT',
  'TCC0402X7R102K500AT',
  'TCC0402X7R103K500AT',
  'TCC0402X7R104K160AT',
  'TCC0402X7R104K250AT',
  'TCC0402X7R104K500AT',
  'TCC0402X7R151K500AT',
  'TCC0402X7R181K500AT',
  'TCC0402X7R221J500AT',
  'TCC0402X7R224K160AT',
  'TCC0402X7R392K500AT',
  'TCC0402X7R472K500AT',
  'TCC0402X7R681K500AT',
  'TCC0402X7R682K500AT',
  'TCC0402X7R683K500AT',
  'TCC0603C0G330J500CT',
  'TCC0603COG101J500CT',
  'TCC0603X5R105K160CT',
  'TCC0603X5R106K100CT',
  'TCC0603X5R106M100CT',
  'TCC0603X5R106M160CT',
  'TCC0603X5R106M6R3CT',
  'TCC0603X5R106M6R3CTN',
  'TCC0603X5R106M6R3CTX',
  'TCC0603X5R226M100CT',
  'TCC0603X5R226M6R3CT',
  'TCC0603X5R226M6R3CTX',
  'TCC0603X5R475K100CT',
  'TCC0603X5R475K160CT',
  'TCC0603X5R475K6R3CT',
  'TCC0603X7R102K101CT',
  'TCC0603X7R102K500CT',
  'TCC0603X7R103K101CT',
  'TCC0603X7R103K500CT',
  'TCC0603X7R104K500CT',
  'TCC0603X7R153K500CT',
  'TCC0603X7R184K500CT',
  'TCC0603X7R221K500CT',
  'TCC0603X7R222K500CT',
  'TCC0603X7R332K500CT',
  'TCC0603X7R471K500CT',
  'TCC0603X7R474K250CT',
  'TCC0805C0G330J500BT',
  'TCC0805C0G470J500BT',
  'TCC0805COG101J251BT',
  'TCC0805X5R106K100FT',
  'TCC0805X5R106K160FT',
  'TCC0805X5R106K160FTN',
  'TCC0805X5R106K250FT',
  'TCC0805X5R226K6R3FT',
  'TCC0805X5R226M100FT',
  'TCC0805X5R226M160FT',
  'TCC0805X5R226M250FT',
  'TCC0805X5R226M6R3FT',
  'TCC0805X5R475K100FT',
  'TCC0805X5R475K160FT',
  'TCC0805X5R475K250FT',
  'TCC0805X5R476M6R3FT',
  'TCC0805X7R102K101DT',
  'TCC0805X7R102K500DT',
  'TCC0805X7R102K501DTS',
  'TCC0805X7R103K500DT',
  'TCC0805X7R105K500FTA',
  'TCC0805X7R106K160FT',
  'TCC0805X7R334K500FT',
  'TCC0805X7R471K501DT',
  'TCC0805X7R475K250FT',
  'TCC1206X5R107M6R3HT',
  'TCC1206X5R226K100HT',
  'TCC1206X5R226M160HT',
  'TCC1206X7R102K102DTS',
  'TCC1206X7R102K102FT',
  'TCC1206X7R102K202FT',
  'TCC1206X7R103K102FT',
  'TCC1206X7R104K101FT',
  'TCC1206X7R105K101HT',
  'TCC1206X7R106K160HT',
  'TCC1206X7R224K101DT',
  'TCC1206X7R225K101HT',
  'TCC1206X7R471K102DTS',
  'TCC1210X5R476M160MT',
  'TCCO201X5R104K160ZT',
  'TCCO402X7R473K160AT',
  'TCCO402X7R473K250AT',
  'TCCO603X7R104K101CT'
];
//电容-SINCERA的型号
const DRSINCERA = [
  '0402X105K250CT',
  '0201B102K500CT',
  '0201B103K500',
  '0201N0R1B500CT',
  '0201N0R2C500',
  '0201N0R3B500',
  '0201N0R3B500CT',
  '0201N0R4B500',
  '0201N0R4B500CT',
  '0201N0R5C500CT',
  '0201N0R6C500',
  '0201N0R6C500CT',
  '0201N0R8C500CT',
  '0201N100J500',
  '0201N100J500CT',
  '0201N101J500CT',
  '0201N120J250',
  '0201N1R0B500CT',
  '0201N1R0C500CT',
  '0201N1R2B500',
  '0201N1R2B500CT',
  '0201N1R2C500CT',
  '0201N1R3B500',
  '0201N1R3B500CT',
  '0201N1R5B500CT',
  '0201N1R5C500CT',
  '0201N1R8C500CT',
  '0201N220J500',
  '0201N220J500CT',
  '0201N2R0C500CT',
  '0201N2R2B500CT',
  '0201N2R2C500CT',
  '0201N2R4C500CT',
  '0201N2R7C500CT',
  '0201N330J500CT',
  '0201N3R0B500CT',
  '0201N3R0C500',
  '0201N3R3B500CT',
  '0201N3R9B500',
  '0201N3R9C500CT',
  '0201N4R7C500CT',
  '0201N5R0C500CT',
  '0201N5R6C500',
  '0201N6R8C500',
  '0201N8R2C500',
  '0201N9R0D500CT',
  '0201N9ROC500CT',
  '0201NNR2B500CT',
  '0201NOR2B500CT',
  '0201X103K100',
  '0201X104K100CT',
  '0201X104K6R3',
  '0201X104K6R3CT',
  '0201X105K6R3CT',
  '0201X473K6R3CT',
  '0402B102K500CT',
  '0402B103K500CT',
  '0402B104K160CT',
  '0402B104K250',
  '0402B154K160CT',
  '0402B392K500CT',
  '0402N0R2B500',
  '0402N0R2B500CT',
  '0402N0R3B500CT',
  '0402N0R5B500CT',
  '0402N0R5C500CT',
  '0402N0R8C500CT',
  '0402N100J500CT',
  '0402N101J500CT',
  '0402N1R0B500',
  '0402N1R0C500CT',
  '0402N1R2C500CT',
  '0402N1R5C500CT',
  '0402N1R8C500CT',
  '0402N200F500',
  '0402N220J500',
  '0402N220J500CT',
  '0402N2R0C500CT',
  '0402N2R2C500CT',
  '0402N2R4C500CT',
  '0402N2R7C500',
  '0402N360J500CT',
  '0402N3R0C500',
  '0402N3R3C500CT',
  '0402N3R9C500',
  '0402N4R7C500CT',
  '0402N5R0C500CT',
  '0402N5R6C500CT',
  '0402N9R0C500CT',
  '0402NOR3B500CT',
  '0402X106M100CT',
  '0402X225M100CT',
  '0402X475M100CT',
  '0603B103K500CT',
  '0603B223K101CT',
  '0603N101J500CT',
  '0603N561J500CT',
  '0603X106M6R3CT',
  '0603X226M6R3CT',
  '0603X475K160CT',
  '0805B104K500',
  '1206B102K202CT',
  '1206B222K102CT',
  '1206X7R102K2KV',
  'RF03N0R2B500CT',
  'RF03N100J500CT',
  'RF03N1R1B250CT',
  'RF03N1R2B250CT',
  'RF03N1R5B250CT',
  'RF03N220J250CT',
  'RF03N3R3B250CT',
  'RF03N9R0B500',
  '0201N1R2C500CT'
];
//电容-SAMSUNG的型号
const DRSAMSUNG = [
  'CL21A475KAQNNNE',
  'CL03A105MP3NSNC',
  'CL03A105MP3NSNH',
  'CL03A105MQ3CSNC',
  'CL03A225MP3CRNC',
  'CL03A225MQ3CRNC',
  'CL03A475MQ5C65C',
  'CL05A105K05NNNC',
  'CL05A105KA5NQNC',
  'CL05A105KO5NNNC',
  'CL05A105KP5NNNC',
  'CL05A105KQ5NNNC',
  'CL05A106MP5NUNC',
  'CL05A106MQ5NUNC',
  'CL05A225MQ5NNNC',
  'CL05A225MQ5NSNC',
  'CL05A475KP5NRNC',
  'CL05A475MO5NUNC',
  'CL10A105K08NNNC',
  'CL10A105KP8NNNC',
  'CL10A106KP8NNNC',
  'CL10A106MO8NQNC',
  'CL10A106MP8NNNC',
  'CL10A106MQ8NNNC',
  'CL10A225K08NNNC',
  'CL10A226MP8NRNC',
  'CL10A226MQ8NRNE',
  'CL10A475KO8NNNC',
  'CL10A475KP8NNNC',
  'CL10A475KQ8NNNC',
  'CL10B105KA8NNNC',
  'CL10B225KO8NNNC',
  'CL10B474KA8NNNC',
  'CL21A106KAYNNNE',
  'CL21A106KOQNNNE',
  'CL21A226KQQNNNE',
  'CL21A226MAQNNNE',
  'CL21A226MOQNNNE',
  'CL21A226MPQNNNE',
  'CL21A226MQQNNNE',
  'CL21A475KAQNNNE',
  'CL21A476MPYNNWE',
  'CL21B105KBFNNNE',
  'CL31A106KAHNNNE',
  'CL31A106KBHNNNE',
  'CL31A226KOHNNNE',
  'CL31A476MPHNNNE',
  'CL31A476MQHNNNE',
  'CL31B105KCHNNNE'
];
//电容-ketuo的型号
const DRketuo = [
  '1000UF16V',
  '100UF16V',
  '100UF25V',
  '10UF 50V',
  '10UF100V',
  '10UF400V',
  '220UF10V',
  '220UF16V',
  '220UF25V',
  '220UF35V',
  '330UF16V',
  '330UF63V',
  '4.7UF50V',
  '47016VPB',
  '470UF10V',
  '470UF16V',
  '470UF25V',
  '47UF100V',
  '47UF400V',
  '6.8UF400V',
  '680UF16V'
];

//电容-FH的型号
const DRFH = [
  '0201CG101J500NT',
  '0201CG270J500NT',
  '0201X224M6R3NT',
  '0201X474K6R3NT',
  '0402B104K160NT',
  '0402B104K250NT',
  '0402B104K500NT',
  '0402B151K500NT',
  '0402B332K500NT',
  '0402CG101J500NT',
  '0402CG102J500NT',
  '0402CG390J500NT',
  '0805B102K500NT',
  '0805B224K101NT',
  '1206B102K102NT',
  '1206B102K202NT'
];

//电容-YAGEO的型号
const DRYAGEO = [
  'CC0402KRX7R7BB104',
  'CC0402KRX7R9BB103',
  'CC0201BRNPO8BN5R6',
  'CC0201JRNPO9BN150',
  'CC0201KRX5R5BB104',
  'CC0402JRNPO9BN150',
  'CC0402JRNPO9BN180',
  'CC0402JRNPO9BN220',
  'CC0402JRNPO9BN221',
  'CC0402KRX7R8BB104',
  'CC0402KRX7R9BB222',
  'CC0603JRNPO9BN470',
  'CC0603KRX7R0BB104'
];

//电容-EYANG的型号
const DREYANG = [
  'C0201C0G120J250NTA',
  'C0201C0G180F500NTA',
  'C0201C0G560J250NTA',
  'C0201COG150F50ONTA',
  'C0201X5R103K100NTA',
  'C0201X5R104K100NTA',
  'C0201X5R332K160NTA',
  'C0201X7R102J250NTA',
  'C0402C0G100C500NTB',
  'C0402C0G270J500NTB',
  'C0402C0G560J500NTB',
  'CO201COG150F50ONTA'
];
//电容-GJT的型号
const DRGJT = [
  '1000UF16V',
  '100UF400V',
  '10UF400V',
  '1UF50V',
  '2200UF16V',
  '22016VHC',
  '33UF400V',
  '47UF100V',
  'RL477M1C0812CCE',
  'RL477M1E0812CCE',
  'UT11H101M0810VG'
];

//电容-无品牌的型号
const DRWPP = [
  '22016VHC',
  '22016VVT',
  '470UF16V',
  '47UF16V',
  'C0402C0G560J500NTB',
  'C0402X7R682K500NTB',
  'Y5P-331K',
  'Y5V-102M/1KV'
];

//电容-Sunlord的型号
const DRSunlord = [
  'TC212A226M010Y',
  'TAIYO YUDEN',
  'EMK105ABJ225KV-F',
  'JMK105CBJ106MV-F',
  'LDK063BBJ225MPLF'
];
//电容-松田的型号
const DRST = [
  'Q07B3D101KA5B0S0N0',
  'Q07F3D102MA3B0S0N0',
  'Q07F3D102MA5B0S0N0',
  'Q10F3D332MA0B0S0NS',
  'X2Q3224KQ135180135075ES0'
];
//电容-Chang的型号
const DRC = [
  '100UF400V',
  '2200UF16V',
  '4.7UF50V'
];
//电容-嵩隆力上的型号
const DRS = [
  'Y5P-331K',
  'Y5V-102M/2KV',
  'Y5V-222M/400V'
];

//电容-GAJITONE的型号
const DRG = [
  '470UF16V',
  'RL.3.3UF 50V'
];

//电容-STE的型号
const DRSTE = [
  'SQ-02-C-00017',
  'X2334K275VAC'
];
//电容-XIANGYEE的型号
const DRX = [
  'CA45-A010M226T',
  'CA45-B6R3K227T'
];
//电容-KEMET的型号
const DRKEMET = [
  'T491C227K010AT',
];
//电容-muRata的型号
const DRM = [
  'GRM0335C1HR50BA01D',
];
//电容-SAMYOUNG的型号
const DRSA = [
  'MVK16VC470M',
];
//电容-湘江的型号
const DRXJ = [
  'CA45-C010K227T',
];
// =====================
//电阻-SUNWAY的型号
const DZ1 = [
  'SC0201F1001G1BNRH',
  'SC0201F1002G1BNRH',
  'SC0201F1003G1BMRH',
  'SC0201F1003G1BNRH',
  'SC0201F10R0I1BNRH',
  'SC0201F1102G1BNRH',
  'SC0201F1103G1BNRH',
  'SC0201F1203G1BNRH',
  'SC0201F1501G1BNRH',
  'SC0201F1502G1BNRH',
  'SC0201F1503G1BNRH',
  'SC0201F2000G1BNRH',
  'SC0201F2002G1BNRH',
  'SC0201F22R0G1BNRH',
  'SC0201F2400G1BNRH',
  'SC0201F2402G1BNRH',
  'SC0201F2432G1BNRH',
  'SC0201F2491G1BNRH',
  'SC0201F4701G1BNRH',
  'SC0201F4702G1BNRH',
  'SC0201F49R9G1BNRH',
  'SC0201F5101G1BNRH',
  'SC0201F51R0G1BNRH',
  'SC0201F56R2G1BNRH',
  'SC0201F6201G1BNRH',
  'SC0201F6802G1BNRH',
  'SC0201F6R80I1BNRH',
  'SC0201J0000I1BNRH',
  'SC0201J1000G1BNRH',
  'SC0201J1001G1BNRH',
  'SC0201J1002G1BNRH',
  'SC0201J1003G1BNRH',
  'SC0201J2201G1BNRH',
  'SC0201J22R0G1BNRH',
  'SC0201J3300G1BNRH',
  'SC0201J33R0G1BNRH',
  'SC0201J3600G1BNRH',
  'SC0201J4701G1BNRH',
  'SC0201J4702G1BNRH',
  'SC0201J5100G1BNRH',
  'SC0201J6802G1BNRH',
  'SC0402F1000F2ANRH',
  'SC0402F1001F2ANRH',
  'SC0402F1002F2ANRH',
  'SC0402F1003F2ANRH',
  'SC0402F1052F2ANRH',
  'SC0402F10R0G2ANRH',
  'SC0402F10R0GA2ANRH',
  'SC0402F1102F2ANRH',
  'SC0402F1103F2ANRH',
  'SC0402F1182F2ANRH',
  'SC0402F1201F2ANRH',
  'SC0402F1202F2ANRH',
  'SC0402F1203F2ANRH',
  'SC0402F1212F2ANRH',
  'SC0402F1241F2ANRH',
  'SC0402F1242F2ANRH',
  'SC0402F1243F2ANRH',
  'SC0402F1303F2ANRH',
  'SC0402F1332F2ANRH',
  'SC0402F1372F2ANRH',
  'SC0402F1402F2ANRH',
  'SC0402F1471F2ANRH',
  'SC0402F1472F2ANRH',
  'SC0402F1500F2ANRH',
  'SC0402F1501F2ANRH',
  'SC0402F1502F2ANRH',
  'SC0402F1503F2ANRH',
  'SC0402F15R0F2ANRH',
  'SC0402F1802F2ANRH',
  'SC0402F1803F2ANRH',
  'SC0402F1821F2ANRH',
  'SC0402F1R00G2ANRH',
  'SC0402F2000F2ANRH',
  'SC0402F2001F2ANRH',
  'SC0402F2002F2ANRH',
  'SC0402F2003F2ANRH',
  'SC0402F20R0F2ANRH',
  'SC0402F2152F2ANRH',
  'SC0402F2202F2ANRH',
  'SC0402F22R0F2ANRH',
  'SC0402F2400F2ANRH',
  'SC0402F2402F2ANRH',
  'SC0402F2491F2ANRH',
  'SC0402F2492F2ANRH',
  'SC0402F2612F2ANRH',
  'SC0402F2673F2ANRH',
  'SC0402F2700F2ANRH',
  'SC0402F2942F2ANRH',
  'SC0402F3000F2ANRH',
  'SC0402F3001F2ANRH',
  'SC0402F3012F2ANRH',
  'SC0402F3302F2ANRH',
  'SC0402F3322F2ANRH',
  'SC0402F33R0F2ANRH',
  'SC0402F3402F2ANRH',
  'SC0402F3601F2ANRH',
  'SC0402F40R2F2ANRH',
  'SC0402F4701F2ANRH',
  'SC0402F4702F2ANRH',
  'SC0402F4703F2ANRH',
  'SC0402F4752F2ANRH',
  'SC0402F4991F2ANRH',
  'SC0402F4992F2ANRH',
  'SC0402F49R9F2ANRH',
  'SC0402F5100F2ANRH',
  'SC0402F5101F2ANRH',
  'SC0402F5102F2ANRH',
  'SC0402F51R0F2ANRH',
  'SC0402F5231F2ANRH',
  'SC0402F5491F2ANRH',
  'SC0402F5601F2ANRH',
  'SC0402F5602F2ANRH',
  'SC0402F56R2F2ANRH',
  'SC0402F5761F2ANRH',
  'SC0402F5R10G2ANRH',
  'SC0402F6041F2ANRH',
  'SC0402F6191F2ANRH',
  'SC0402F6201F2ANRH',
  'SC0402F6802F2ANRH',
  'SC0402F6803F2ANRH',
  'SC0402F7502F2ANRH',
  'SC0402F75R0F2ANRH',
  'SC0402F8201F2ANRH',
  'SC0402F8202F2ANRH',
  'SC0402F9092F2ANRH',
  'SC0402F9101F2ANRH',
  'SC0402F9102F2ANRH',
  'SC0402F9310F2ANRH',
  'SC0402F9311F2ANRH',
  'SC0402F9761F2ANRH',
  'SC0402F9762F2ANRH',
  'SC0402J0000I2ANRH',
  'SC0402J1000F2ANRH',
  'SC0402J1001F2ANRH',
  'SC0402J1002F2ANRH',
  'SC0402J1003F2ANRH',
  'SC0402J10R0G2ANRH',
  'SC0402J1200F2ANRH',
  'SC0402J1202F2ANRH',
  'SC0402J1203F2ANRH',
  'SC0402J1500F2ANRH',
  'SC0402J1501F2AMRH',
  'SC0402J1501F2ANRH',
  'SC0402J1502F2ANRH',
  'SC0402J1503F2ANRH',
  'SC0402J2000F2ANRH',
  'SC0402J2001F2ANRH',
  'SC0402J2002F2ANRH',
  'SC0402J2200F2ANRH',
  'SC0402J2202F2ANRH',
  'SC0402J22R0F2ANRH',
  'SC0402J2400F2ANRH',
  'SC0402J2R20G2ANRH',
  'SC0402J3000F2ANRH',
  'SC0402J3002F2ANRH',
  'SC0402J3300F2ANRH',
  'SC0402J3302F2ANRH',
  'SC0402J33R0F2ANRH',
  'SC0402J3601F2ANRH',
  'SC0402J3901F2ANRH',
  'SC0402J4700F2ANRH',
  'SC0402J4701F2ANRH',
  'SC0402J4702F2ANRH',
  'SC0402J5100F2ANRH',
  'SC0402J5102F2ANRH',
  'SC0402J5600F2ANRH',
  'SC0402J56R0F2ANRH',
  'SC0402J6202F2ANRH',
  'SC0402J6800F2ANRH',
  'SC0402J6802F2ANRH',
  'SC0402J75R0F2ANRH',
  'SC0603F0000I2BNRH',
  'SC0603F1001F2BNRH',
  'SC0603F1002F2BNRH',
  'SC0603F1003F2BNRH',
  'SC0603F1052F2BNRH',
  'SC0603F1R00G2BNRH',
  'SC0603F2002F2BNRH',
  'SC0603F2492F2BNRH',
  'SC0603F28R7F2BNRH',
  'SC0603F3001F2BNRH',
  'SC0603F3002F2BNRH',
  'SC0603F3602F2BNRH',
  'SC0603F4R70G2BNRH',
  'SC0603F6191F2BNRH',
  'SC0603F7321F2BNRH',
  'SC0603F75R0F2BNRH',
  'SC0603J0000I2BNRH',
  'SC0603J1001F2BNRH',
  'SC0603J1002F2BNRH',
  'SC0603J10R0G2BNRH',
  'SC0603J1502F2BNRH',
  'SC0603J3300F2BNRH',
  'SC0603J4701F2BNRH',
  'SC0603J5101F2BNRH',
  'SC0603J75R0F2BNRH',
  'SC0805F1000F4ANRH',
  'SC0805F10R0G4ANRH',
  'SC0805F1202F4ANRH',
  'SC0805F1204F4ANRH',
  'SC0805F1500F4ANRH',
  'SC0805F2402F4ANRH',
  'SC0805F4302F4ANRH',
  'SC0805F4303F4ANRH',
  'SC0805F4700F4ANRH',
  'SC0805F4701F4ANRH',
  'SC0805F4702F4ANRH',
  'SC0805F4R70G4ANRH',
  'SC0805F5601F4ANRH',
  'SC0805F6201F4ANRH',
  'SC0805F7501F4ANRH',
  'SC0805J0000I4ANRH',
  'SC0805J1001F4ANRH',
  'SC0805J1002F4ANRH',
  'SC0805J1003F4ANRH',
  'SC0805J2001F4ANRH',
  'SC0805J4702F4ANRH',
  'SC0805J5101F4ANRH',
  'SC0805J51R0F4ANRH',
  'SC1206F1R60G8ANRH',
  'SC1206F2001F8ANRH',
  'SC1206F3R00G8ANRH',
  'SC1206F7501F8ANRH',
  'SC1206J0000I8ANRH',
  'SC1206J1002F8ANRH',
  'SC1206J1003F8ANRH',
  'SC1206J2004F8ANRH',
  'SC1206J3003F8ANRH',
  'SC1206J3300F8ANRH',
  'SC1206J4703F8ANRH',
  'SC1206J5103F8ANRH'
];

//电阻-UniOhm的型号
const DZ2 = [
  '0805W8F3901T5E',
  '0201WMF1000TEE',
  '0201WMF1001TEE',
  '0201WMF1002TEE',
  '0201WMF1003TEE',
  '0201WMF100JTEE',
  '0201WMF1102TEE',
  '0201WMF1103TEE',
  '0201WMF1500TEE',
  '0201WMF1502TEE',
  '0201WMF1503TEE',
  '0201WMF1783TEE',
  '0201WMF180JTEE',
  '0201WMF2000TEE',
  '0201WMF2201TEE',
  '0201WMF2202TEE',
  '0201WMF220JTEE',
  '0201WMF2400TEE',
  '0201WMF2491TEE',
  '0201WMF3003TEE',
  '0201WMF3302TEE',
  '0201WMF3321TEE',
  '0201WMF4700TEE',
  '0201WMF470JTEE',
  '0201WMF499JTEE',
  '0201WMF5102TEE',
  '0201WMF510KTEE',
  '0201WMF6201TEE',
  '0201WMF6802TEE',
  '0201WMF680KTEE',
  '0201WMF7872TEE',
  '0201WMF825JTEE',
  '0201WMF931JTEE',
  '0201WMJ0000TEE',
  '0201WMJ0101TEE',
  '0201WMJ0102TEE',
  '0201WMJ0103TEE',
  '0201WMJ0104TEE',
  '0201WMJ0330TEE',
  '0201WMJ0361TEE',
  '0201WMJ0472TEE',
  '0201WMJ0473TEE',
  '0201WMJ0511TEE',
  '0201WMJ0681TEE',
  '0402WG4122TCE',
  '0402WGF010JTCE',
  '0402WGF1000TCE',
  '0402WGF1001TCE',
  '0402WGF1002TCE',
  '0402WGF1003TCE',
  '0402WGF1004TCE',
  '0402WGF100KTCE',
  '0402WGF1022TCE',
  '0402WGF1103TCE',
  '0402WGF1153TCE',
  '0402WGF1180TCE',
  '0402WGF1200TCE',
  '0402WGF1201TCE',
  '0402WGF1202TCE',
  '0402WGF120JTCE',
  '0402WGF120TCE',
  '0402WGF1212TCE',
  '0402WGF1241TCE',
  '0402WGF1273TCE',
  '0402WGF1302TCE',
  '0402WGF1303TCE',
  '0402WGF1502TCE',
  '0402WGF1503TCE',
  '0402WGF150JTCE',
  '0402WGF1743TCE',
  '0402WGF180JTCE',
  '0402WGF2001TCE',
  '0402WGF2002TCE',
  '0402WGF2003TCE',
  '0402WGF200KTCE',
  '0402WGF2052TCE',
  '0402WGF2200TCE',
  '0402WGF2202TCE',
  '0402WGF220JTCE',
  '0402WGF220KTCE',
  '0402WGF2210TCE',
  '0402WGF2212TCE',
  '0402WGF2322TCE',
  '0402WGF2400TCE',
  '0402WGF2402TCE',
  '0402WGF2490TCE',
  '0402WGF2491TCE',
  '0402WGF2492TCE',
  '0402WGF2673TCE',
  '0402WGF2700TCE',
  '0402WGF2872TCE',
  '0402WGF3003TCE',
  '0402WGF330JTCE',
  '0402WGF3322TCE',
  '0402WGF3401TCE',
  '0402WGF3402TCE',
  '0402WGF3481TCE',
  '0402WGF390JTCE',
  '0402WGF402JTCE',
  '0402WGF4122TCE',
  '0402WGF4752TCE',
  '0402WGF4991TCE',
  '0402WGF4992TCE',
  '0402WGF499JTCE',
  '0402WGF499KTCE',
  '0402WGF5101TCE',
  '0402WGF510KTCE',
  '0402WGF5231TCE',
  '0402WGF5761TCE',
  '0402WGF6201TCE',
  '0402WGF6202TCE',
  '0402WGF6802TCE',
  '0402WGF6803TCE',
  '0402WGF6812TCE',
  '0402WGF6982TCE',
  '0402WGF7502TCE',
  '0402WGF7503TCE',
  '0402WGF750JTCE',
  '0402WGF7682TCE',
  '0402WGF8200TCE',
  '0402WGF8201TCE',
  '0402WGF8661TCE',
  '0402WGF9310TCE',
  '0402WGF953JTCE',
  '0402WGF9762TCE',
  '0402WGF976JTCE',
  '0402WGF976TCE',
  '0402WGJ0000TCE',
  '0402WGJ0101TCE',
  '0402WGJ0102TCE',
  '0402WGJ0103TCE',
  '0402WGJ0104TCE',
  '0402WGJ010JTCE',
  '0402WGJ0152TCE',
  '0402WGJ0154TCE',
  '0402WGJ0163TCE',
  '0402WGJ0201TCE',
  '0402WGJ0202TCE',
  '0402WGJ0205TCE',
  '0402WGJ0221TCE',
  '0402WGJ0223TCE',
  '0402WGJ0303TCE',
  '0402WGJ0330TCE',
  '0402WGJ0331TCE',
  '0402WGJ0471TCE',
  '0402WGJ0472TCE',
  '0402WGJ0473TCE',
  '0402WGJ0511TCE',
  '0402WGJ0561TCE',
  '0402WGJ0910TCE',
  '0402WJ0472TCE',
  '0603WAF0000T5E',
  '0603WAF1001T5E',
  '0603WAF1002T5E',
  '0603WAF2000T5E',
  '0603WAF2001T5E',
  '0603WAF2002T5E',
  '0603WAF2432T5E',
  '0603WAF2552T5E',
  '0603WAF287JT5E',
  '0603WAF3011T5E',
  '0603WAF4702T5E',
  '0603WAF487JT5E',
  '0603WAF6342T5E',
  '0603WAF6492T5E',
  '0603WAF6813T5E',
  '0603WAF7321T5E',
  '0603WAF750JT5E',
  '0603WAJ0750T5E',
  '060WAJ0121T5E',
  '0803WAJ0750T5E',
  '0805W8F1003T5E',
  '0805W8F1004T5E',
  '0805W8F1151T5E',
  '0805W8F150JT5E',
  '0805W8F1601T5E',
  '0805W8F3301T5E',
  '0805W8F470KT5E',
  '0805W8F6802T5E',
  '0805W8J0000T5E',
  '0805W8J0103T5E',
  '0805W8J0154T5E',
  '0805W8J0220T5E',
  '0805W8J0273T5E',
  '0805W8J0473T5E',
  '0805W8J0510T5E',
  '0805W8J051JT5E',
  '0805W8J0560T5E',
  '0805W8J0561T5E',
  '0805W8J068JT5E',
  '1206W4F1000T5E',
  '1206W4F1003T5E',
  '1206W4F1004T5E',
  '1206W4F470LT5E',
  '1206W4J0103T5E',
  '1206W4J0104T5E',
  '1206W4J0124T5E',
  '1206W4J0145T5E',
  '1206W4J0200T5E',
  '1206W4J0205T5E',
  '1206W4J022JT5E',
  '1206W4J0684T5E',
  'WR12W1R60FTL',
  '0201WMF499JTEE'
];

//电阻-SINCERA的型号
const DZ3 = [
  'WR02X3301FTL',
  'WR02W5R10FTL',
  'WR02W6R80FAL',
  'WR02X1272FAL',
  'WR02X133JAL',
  'WR02X1403FTL',
  'WR02X1500FTL',
  'WR02X243 JTL',
  'WR02X2491FAL',
  'WR02X2492FAL',
  'WR02X2493FAL',
  'WR02X3162FAL',
  'WR02X3242FTL',
  'WR02X363JAL',
  'WR02X4022FAL',
  'WR02X472JAL',
  'WR02X4991FAL',
  'WR02X4992FTL',
  'WR02X5602FTL',
  'WR02X5901FTL',
  'WR02X60R4FAL',
  'WR02X6202FTL',
  'WR02X6341FAL',
  'WR02X75R0FTL',
  'WR02X8201FTL',
  'WR04W1R00FTL',
  'WR04W4R99FTL',
  'WR04X1001FTL',
  'WR04X101JTLJ',
  'WR04X102JTL',
  'WR04X103JTLJ',
  'WR04X104JTL',
  'WR04X1202FTL',
  'WR04X1241FTL',
  'WR04X1372FTL',
  'WR04X1473FTL',
  'WR04X150 JTL',
  'WR04X1500FTL',
  'WR04X153JTL',
  'WR04X205 JTL',
  'WR04X20R0FTL',
  'WR04X2150FTL',
  'WR04X303JTLJ',
  'WR04X39R0FTL',
  'WR04X4422FTL',
  'WR04X472JTL',
  'WR04X472JTLJ',
  'WR04X512JTL',
  'WR04X7503FT',
  'WR04X75R0FTL',
  'WR04X95R3FTL',
  'WR06X0000FTL',
  'WR06X000PTL',
  'WR06X1001FTL',
  'WR06X1003FTL',
  'WR06X1912FTL',
  'WR06X2003FTL',
  'WR06X3602FTL',
  'WR06X3741FTL',
  'WR06X4301FTL',
  'WR06X4702FTL',
  'WR06X473JTL',
  'WR06X48R7FTL',
  'WR08W2R40FTL',
  'WR08W5R10FTL',
  'WR08X103 JTL',
  'WR08X1151FTL',
  'WR08X1500FTL',
  'WR08X154JTL',
  'WR08X3002FTL',
  'WR08X512 JTL',
  'WR12W1R00FTL',
  'WR12W2R00FTL',
  'WR12W3R00FTL',
  'WR12X000PTL',
  'WR12X225JTL',
  'WR12X2R2 JTL',
  'WR12X510JTL'
];

//电阻-ROYALOHM的型号
const DZ4 = [
  '0805W8J0394T5E',
  'R0805J-56R-HS',
  '0201WMF1002TEE',
  '0201WMF1742TEE',
  '0201WMF2000TEE',
  '0201WMF220KTEE',
  '0201WMF2432TEE',
  '0201WMF4700TEE',
  '0201WMF499JTEE',
  '0201WMF5102TEE',
  '0201WMF5600TEE',
  '0201WMF680KTEE',
  '0201WMJ0473TEE',
  '0201WMJ0511TEE',
  '0402WGF1003TCE',
  '0402WGF100KTCE',
  '0402WGF1022TCE',
  '0402WGF1153TCE',
  '0402WGF1180TCE',
  '0402WGF1203TCE',
  '0402WGF14021CE',
  '0402WGF1473TCE',
  '0402WGF1502TCE',
  '0402WGF2003TCE',
  '0402WGF2150TCE',
  '0402WGF2210TCE',
  '0402WGF2212TCE',
  '0402WGF2322TCE',
  '0402WGF2490TCE',
  '0402WGF2612TCE',
  '0402WGF2673TCE',
  '0402WGF3003TCE',
  '0402WGF3401TCE',
  '0402WGF402LTCE',
  '0402WGF4991TCE',
  '0402WGF4993TCE',
  '0402WGF499KTCE',
  '0402WGF5102TCE',
  '0402WGF510KTCE',
  '0402WGF5491TCE',
  '0402WGF5902TCE',
  '0402WGF680JTCE',
  '0402WGF7322TCE',
  '0402WGF750JTCE',
  '0402WGF8200TCE',
  '0402WGF8871TCE',
  '0402WGJ0163TCE',
  '0402WGJ0333TCE',
  '0402WGJ0753TCE',
  '0603WAF1401T5E',
  '0603WAF2051T5E',
  '0603WAF5362T5E',
  '0603WAJ0750T5E',
  '0805W8F1500T5E',
  '0805W8F3002T5E',
  '0805W8J0102T5E',
  '1206W4F1000T5E',
  '1206W4F2001T5E',
  '1206W4F220JT5E',
  '1206W4F300KT5E',
  '1206W4F470LT5E',
  '1206W4F680JT5E',
  '1206W4F7501T5E',
  '1206W4J0394T5E'
];

//电阻-FH的型号
const DZ5 = [
  'RC-02000JT',
  'RC-02K330JT',
  'RC-02K331JT',
  'RC-02K472JT',
  'RS-03000JT',
  'RS-05000JT',
  'RS-06000FT'
];

//电阻-RALEC的型号
const DZ6 = [
  'R2527Q06B5',
  'RTT012401FTH',
  'RTT015902FTH',
  'RTT017681FTH',
  'RTT021910FTH',
  'RTT05512JTP',
  'RTT059101FTP'
];
//电阻-YAGEO的型号
const DZ7 = [
  'RC0402FR-07240RL',
  'RC0402FR-07267KL',
  'RC0402FR-0759KL',
  'RC0402JR-070RL',
  'RC0402JR-0710RL'
];
//电阻-无品牌的型号
const DZ8 = [
  'RXF-1WS-4.7R-J-T52',
  'RXF-2WS-4.7R-J',
  'VDR-05D561K'
];

//电阻-SEMBO的型号
const DZ9 = [
  'SBV100505M20100NT',
  'SBV100505M26047NT'
];

//电阻-HONGDA的型号
const DZ10 = [
  'RXF-1WS-4.7R-J-T52',
  'RXF-2WS-4.7R-J-T63'
];

//电阻-VDR的型号
const DZ11 = [
  '10D561K'
];

//电阻-嵩隆力上的型号
const DZ12 = [
  'VDR 10D561K'
];
// =======================
//电感-Ceaiya的型号
const DG1 = [
  'CMPI0420-R33M',
  'CMPI0518-3R3M',
  'CMPI0518-4R7M',
  'CMPI0518-R47M',
  'CMPI0530-1R2M',
  'CMPI0530-1R5M',
  'CMPI0530-2R2M',
  'CMPI0630-2R2M',
  'CMPI0630-4R7M',
  'CMPI0630-6R8M',
  'CMPI1040D-330M',
  'CR3015-2R2M',
  'CR4020-2R2M',
  'CR4020-3R3M',
  'CR4030-3R3M',
  'CR4030-4R7M',
  'CR5040-2R2M',
  'CR6028-150M',
  'CR6045-100M',
  'CR6045-2R2N',
  'CR6045-4R7M',
  'CR6045K-3R3M',
  'CR6045K-4R7M',
  'CR6045K-6R8M',
  'CRH252012S-1ROMT',
  'CRH252012S-2R2MT',
  'CRH252012S-4R7MT',
  'MA14012A-2R2MT',
  'MAI201610S - 2R2MT',
  'MAI201610S-1R5MT',
  'MAI252010S-1R5MT',
  'MAI4020S-4R7MT',
  'MAI4020S-R47MT',
  'MAI4020S-R68MT',
  '​MAI4020S-2R2MT​'
];
//电感-Sunlord的型号
const DG2 = [
  'GZ1005D121CTF',
  'GZ1005U700CTF',
  'MPH201210S1R0MT',
  'MPH201610S4R7MT',
  'MPH201612S100MT',
  'MWSA0402S-1R2MT',
  'MWSA0402S-1R5MT',
  'MWSA1004S-3R3MT',
  'SDCL0603Q1N0BT02',
  'SDCL0603Q2N7BT02B03',
  'SDCL0603Q3N0BT02B03',
  'SPH252012H4R7MT',
  'SWPA252012S1R0NT',
  'SWPA252012S2R2MT',
  'SWPA3015S2R2MT',
  'SWPA3015S4R7MT',
  'SWPA4020S2R2MT',
  'SWPA6045S2R2NT',
  'SWPA8040S2R0NT',
  'SWPA8040S330MT',
  'UPZ1608E101-3R0TF',
  'UPZ1608U121-3R0TF',
  'UPZ1608U221-2R2TF',
  'WPN201610H1R0MT',
  'WPN201610H1R5MT',
  'WPN201610H2R2MT',
  'WPN201610H4R7MT',
  'WPN201610UR47MT',
  'WPN4012H1R0MT'
];
//电感-无品牌的型号
const DG3 = [
  'AL0510-222K',
  'AL0512-561K-LF',
  'CM04001ST',
  'CM04002ST',
  'CMPI0630-R82M',
  'HMC0603-2R2M',
  'HMCB0502-3R3M',
  'HMCI0630-2R2M',
  'HNR4020-2R2M',
  'HNR4020-4R7M',
  'HNR4020-R33M',
  'HNR4030-2R2M',
  'HNR4030-3R3M',
  'HNR4030-4R7M',
  'HNR5040-4R7M',
  'HNR5040-6R8M',
  'HNR6045-100M',
  'HNR6045-220M',
  'HNR6045-2K2M',
  'HNR6045-3R3M',
  'HNR6045-6R8M',
  'MGFL2520F4R7MT-LF',
  'MGLB3216M601T-LF 3A',
  'RL0610-100M-LF',
  'SCBW201209U121T',
  'WBA0805D801PT-HF',
  'WBA0805D9005PT-04-HF',
  'WBA3416L600T-F-HF',
  'WIP252012S-2R2ML'
];

//电感-YCET的型号
const DG4 = [
  'SCBG100505U331T',
  'SCBG321609U101T',
  'SCBM160808U121TA01',
  'SCBM201209U121T',
  'SCBM201209U601T',
  'SCBW100505U121T',
  'SCBW160808U101T',
  'SCBW160808U601T',
  'SCBW201209U121T',
  'SCBW201209U301T'
];

//电感-microgate的型号
const DG5 = [
  'MGLB0603M121T0R5-LF',
  'MGLB1005M121T1R3-LF',
  'MGLB1005M471T0R5-LF',
  'MGLB1608M121T3R0-LF',
  'MGLB3216M121T3R0-LF',
  'MGLB3216M601T-LF 3A'
];
//电感-Cybermax的型号
const DG6 = [
  'CMBM1005G121GSP',
  'CMBM1005G601GSP',
  'CMLF0504-4R7MTT',
  'CMLW3015S1R0MST',
  'CMLW8040S470MST'
];

//电感-TAI-TECH的型号(TAI-TECH 是品牌字符直接用不影响)
const DG7 = [
  'AHP252010FA-1R5M',
  'FCM1005KF-100T05',
  'HCB1608KF-121T30',
  'HPC8040NF-150M',
  'THPC8040NC-150M'
];

//电感-FH的型号
const DG8 = [
  'CBM060303X121T',
  'CBM100505U221T'
];

//电感-FOUNDS的型号
const DG9 = [
  'PSM0530B4R7M',
  'PSM252012P-4R7ML'
];

//电感-WS的型号
const DG10 = [
  'NR4018-100M',
  'YT0630-6R8M'
];
//电感-JuLian的型号
const DG11 = [
  'CM04001ST',
  'CMO4002ST'
];

//电感-HILISIN的型号
const DG12 = [
  'HNR4020-2R2M',
  'HNR4020-4R7M'
];

//电感-CHILISIN的型号
const DG13 = [
  'PBY201209T-601Y-N'
];

//电感-JY的型号
const DG14 = [
  'JMC0502-3R3MF-L'
];

// 各产品类型下的品牌名称初始化数据（直接复用 DR/DZ/DG 品牌数组）
export const brandNamesByProductType: Record<string, string[]> = {
  "电容": DR,
  "电阻": DZ,
  "电感": DG,
};

// 品牌型号初始化数据：按 `${产品类型}-${品牌名称}` 组合组织，同一品牌在不同产品类型下各自独立一份
export const brandModelsByProductTypeAndBrandName: Record<string, string[]> = {
  // 电容
  "电容-CCTC": DRCCTC,
  "电容-SINCERA": DRSINCERA,
  "电容-SAMSUNG": DRSAMSUNG,
  "电容-ketuo": DRketuo,
  "电容-FH": DRFH,
  "电容-YAGEO": DRYAGEO,
  "电容-EYANG": DREYANG,
  "电容-GJT": DRGJT,
  "电容-无品牌": DRWPP,
  "电容-Sunlord": DRSunlord,
  "电容-松田": DRST,
  "电容-Chang": DRC,
  "电容-嵩隆力上": DRS,
  "电容-GAJITONE": DRG,
  "电容-STE": DRSTE,
  "电容-XIANGYEE": DRX,
  "电容-KEMET": DRKEMET,
  "电容-muRata": DRM,
  "电容-SAMYOUNG": DRSA,
  "电容-湘江": DRXJ,
  // 电阻
  "电阻-SUNWAY": DZ1,
  "电阻-UniOhm": DZ2,
  "电阻-SINCERA": DZ3,
  "电阻-ROYALOHM": DZ4,
  "电阻-FH": DZ5,
  "电阻-RALEC": DZ6,
  "电阻-YAGEO": DZ7,
  "电阻-无品牌": DZ8,
  "电阻-SEMBO": DZ9,
  "电阻-HONGDA": DZ10,
  "电阻-VDR": DZ11,
  "电阻-嵩隆力上": DZ12,
  // 电感
  "电感-Ceaiya": DG1,
  "电感-Sunlord": DG2,
  "电感-无品牌": DG3,
  "电感-YCET": DG4,
  "电感-microgate": DG5,
  "电感-Cybermax": DG6,
  "电感-TAI-TECH": DG7,
  "电感-FH": DG8,
  "电感-FOUNDS": DG9,
  "电感-WS": DG10,
  "电感-JuLian": DG11,
  "电感-HILISIN": DG12,
  "电感-CHILISIN": DG13,
  "电感-JY": DG14,
};

// 对比静态数据与传入的已有字典数据，把静态数据里存在而已有数据里没有的项依次添加到字典
// 返回与待添加项一一对应的结果数组：成功为后端返回的 DictItem，失败为 null
const initDictList = async (type: string, list: string[], existList: string[]) => {
  const existSet = new Set(existList);
  const results: (DictItem | null)[] = [];
  for (const desc of list.filter(item => !existSet.has(item))) {
    try {
      results.push(await addIgnoreEnum(type, { key: desc, desc }));
    } catch {
      results.push(null);
    }
  }
  return results;
};

// existList 为字典中已有的产品类型（desc）列表
export const initProductType = (type: string, existList: string[]) => {
  return initDictList(type, productTypeList, existList);
};

// existList 为字典中已有的品牌名称（desc）列表，productType 为产品类型（字典 type）
export const initBrandName = (productType: string, existList: string[]) => {
  return initDictList(productType, brandNamesByProductType[productType] ?? [], existList);
};

// 品牌型号的字典 type：组合产品类型与品牌名称，使型号同时关联两者（如 "电容-CCTC"）
export const brandModelType = (productType: string, brandName: string) => `${productType}-${brandName}`;

// existList 为字典中已有的品牌型号（desc）列表，型号挂在 `${产品类型}-${品牌名称}` 组合 type 下
export const initBrandModel = (productType: string, brandName: string, existList: string[]) => {
  return initDictList(brandModelType(productType, brandName), brandModelsByProductTypeAndBrandName[brandModelType(productType, brandName)] ?? [], existList);
};